class BackToTop {
    constructor (theme, elem) {
        this.name = this.constructor.name
        this._theme = theme
        this._elem = elem
        this.footer = document.querySelector('.site-footer')
        this.scroll = this.footer.getBoundingClientRect().top
    }
    onInit () {
        if (window.innerWidth > 768) {
            document.addEventListener('scroll', () => {
                this.onScroll()
            })
            this.onScroll()
            this._elem.addEventListener('click', () => {
                window.scrollTo({top: 0, behavior: 'smooth'})
            })
        }
    }
    onScroll () {
        if (scrollY > 400) {
            if (scrollY > this.scroll - 800) {
                this._elem.classList.remove('active')
            } else {
                this._elem.classList.add('active')
            }
        } else {
            this._elem.classList.remove('active')
        }
    }
}

export default BackToTop



// WEBPACK FOOTER //
// ./src/resources/scripts/components/BackToTop.js